module.exports = __webpack_public_path__ + "img/close.31db118c.svg";